export const BITE_DOMAIN = 'bite'

export const API = process.env.REACT_APP_API_URL
export const UI_URL = process.env.REACT_APP_UI_URL
export const CRM_API = process.env.REACT_APP_CRM_API_URL
export const CAMPAIGN_API = process.env.REACT_APP_CAMPAIGN_URL
